import React from "react";
import { useNavigate } from "react-router-dom";
import BatchesWithProgress from "./BatchesWithProgress";
import DashboardCard from "./DashboardCard";
import { Spinner } from "react-bootstrap";
import _ from "lodash";
import EmptyContainer from "../../Components/Container/EmptyContainer";

const ContinueBatches = ({ data = [], loading }) => {
  const navigate = useNavigate();
  return (
    <div>
      <DashboardCard heading={"Continue Batch"}>
        <div className="scrollable">
          {loading ? (
            <div className="w-100 d-flex flex-row justify-content-center">
              <Spinner />
            </div>
          )  : _.isEmpty(data) ? 
                    <EmptyContainer text="Data Not Found" classes="my-2" />
                    : (
            data?.map((item, index) => {
              return (
                <div className="my-3">
                  <BatchesWithProgress key={_.uniqueId()} data={item} />
                </div>
              );
            })
          )}
        </div>
      </DashboardCard>
    </div>
  );
};

export default ContinueBatches;
